module.exports = __webpack_public_path__ + "static/img/n-two.415eb0dd.png";